<script>
	// Partials
	import WageringProxy from '@/Partials/User/_WageringProxy.svelte';
	// Stores
	import ACLStore from '@/Stores/ACLStore.js';
	import UserStore from '@/Stores/UserStore.js';

	export let user;

	let proxy;
	$: user && getProxy();

	function getProxy() {
		proxy = null;
		UserStore.getProxyTokenForUser(user.id).then((result) => {
			proxy = result;
		});
	}
</script>

<div class="p-2 mx-4 bg-gray-100 rounded md:flex md:flex-col">
	<div class="flex items-center px-2 bg-dark-grey text-light">
		<h2 class="flex-1 py-2 text-xl italic font-sans-condensed">
			Bet Back for {user.first_name}
			{user.last_name}
		</h2>
	</div>
	{#if $ACLStore && ACLStore.granted('users.login.betback') && proxy}
		<div class="max-iframe-height">
			<WageringProxy {proxy} />
		</div>
	{/if}
</div>

<style>
	.max-iframe-height {
		height: calc(var(--vh, 1vh) * 100 - 15rem);
	}
</style>
